import { styled } from "@mui/material";
import Component from "./component";

export default styled(Component)(() => ({
  width: "100%",
}));
